// extracted by mini-css-extract-plugin
module.exports = {"tokenform":"TokenLogin_tokenform__1gJ7U","tokenformitem":"TokenLogin_tokenformitem__xc9NW","button":"TokenLogin_button__2qm9z"};